import React from 'react';
import cmsUtils from '../cmsUtils';
import { DashboardLoading } from 'site/members/dashboard/dashboardLoading';

export const renderRule = {
  match: (item, cmsOption) =>
    (cmsUtils.getCodeJson(item) || {})['control'] === 'MemberDashboardV2' && !cmsOption.isCmsEdit,
  itemElt: (item, cmsOption) => <DashboardLoading version = 'v2' />,
};
